import LoadingIndicator from 'components/common/LoadingIndicator';
import { t } from 'services/i18n.service';

const DesktopRedirectLoading = () => (
  <>
    <div className='flex flex-col items-center justify-center ~gap-2/4'>
      <h2 className='font-semibold text-primary-900 dark:text-primary-dark-500'>
        {t('auth_page.opening_desktop_app')}
      </h2>
      <h4 className='~text-xs/base text-primary-300 dark:text-secondary-dark-700 font-normal'>
        {t('auth_page.we_will_redirect_shortly')}
      </h4>
    </div>
    <LoadingIndicator
      dims='~w-6/10 ~min-h-6/10'
      styles='rounded-full border-t-4 border-r border-l-4 border-b border-primary-500 dark:border-primary-dark-500 animate-spin'
    />
  </>
);

export default DesktopRedirectLoading;
